<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <div class="workflow-node workflow-node--goal_check">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">GOAL</div>
        <div class="workflow-node__title">{{ data?.config?.label || 'Goal Exit' }}</div>
    </div>
</template>
